<template>
  <div class="apps-container">
    <div class="warp flex-row">
      <header>
        <span>{{ appList[appIndex].name }}</span>
      </header>
      <ul class="apps">
        <li class="app" v-for="item, index in appList[appIndex].children"
          @click="clickApp(item.sourceType, item.id, item.url)" @mouseenter="openSlider(index)"
          @mouseleave="closeSlider">
          <img :src="baseUrl + item.customIcon">
          <h3>{{ item.name }}</h3>
        </li>
      </ul>
    </div>
    <div class="slider">
      <div class="wrapper">
        <div class="title">
          {{ (appList[appIndex].children && appList[appIndex].children[hoverIndex])
            ? appList[appIndex].children[hoverIndex].name : '' }}
        </div>
        <div class="item"
          v-for="item in ((appList[appIndex].children && appList[appIndex].children[hoverIndex]) ? appList[appIndex].children[hoverIndex].children : '')">
          {{ item.name }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Apps',
  props: ['appIndex', 'appList', 'clickApp'],
  data() {
    return {
      baseUrl: localStorage.getItem('baseUrl'),
      hoverIndex: 0
    }
  },
  methods: {
    openSlider(index) {
      this.hoverIndex = index
      let sliders = document.querySelectorAll('.slider')
      sliders[this.appIndex].style.width = 'calc(250*var(--ratio))'
    },
    closeSlider() {
      let sliders = document.querySelectorAll('.slider')
      sliders[this.appIndex].style.width = 0
    }
  }
}
</script>

<style lang="scss" scoped>
.apps-container {
  height: 100%;
  // background: no-repeat center/cover url('../../assets/apps.png');
  overflow: hidden;
  display: flex;
  position: relative;
  height: 100%;
  width: 100%;
  display: flex;

  .warp {
    margin: auto;
    align-items: flex-start;

    header {
      height: calc(180*var(--ratio));
      width: calc(80*var(--ratio));
      background: $homeRed;
      color: #fff;
      font-size: calc(22*var(--ratio));
      font-weight: bold;
      writing-mode: vertical-lr;
      text-align: center;
      line-height: calc(80*var(--ratio));
      letter-spacing: calc(8*var(--ratio));
      background: linear-gradient(90deg, #b30710, #c93940);
      backdrop-filter: blur(10px);
    }

    .apps {
      display: grid;
      grid-template-columns: repeat(6, calc(180*var(--ratio)));
      grid-template-rows: repeat(auto-fill, calc(180*var(--ratio)));

      .app {
        height: calc(180*var(--ratio));
        cursor: pointer;
        color: #fff;
        padding: calc(30*var(--ratio));
        background: linear-gradient(45deg, #134c9d80, #114b9d59);
        backdrop-filter: blur(10px);
        transition: 300ms;

        &:hover {
          background: #ffffff70;
          color: #333;

          img {
            transform: scale(1.2);
            filter: brightness(1) contrast(1);
          }
        }

        img {
          width: calc(50*var(--ratio));
          height: calc(50*var(--ratio));
          filter: brightness(100) contrast(100);
          transition: transform 300ms ease-in-out;
        }

        h3 {
          margin-top: calc(35*var(--ratio));
          font-size: calc(20*var(--ratio));
        }
      }
    }
  }

  .slider {
    transform: translateX(1px);
    position: absolute;
    top: calc(90*var(--ratio));
    right: 0;
    width: 0;
    transition: 300ms ease-in-out;
    height: calc(100vh - calc(90*var(--ratio)));
    background: linear-gradient(to top, #1850A250 70%, transparent);
    backdrop-filter: blur(10px);
    border-left: 1px solid;
    border-image: linear-gradient(to top, #ffffff90 70%, transparent) 1;
    z-index: 999;
    color: #fff;

    .wrapper {
      padding: calc(150*var(--ratio)) 0 0 calc(50*var(--ratio));

      .title {
        font-size: calc(24*var(--ratio));
        font-weight: bold;
      }

      .item {
        font-size: calc(16*var(--ratio));
        margin-top: calc(30*var(--ratio));
      }
    }
  }
}
</style>